export default __webpack_public_path__ + "static/hero_4-78923f0c1e15ecb3b033ab2fc9791e9c.jpg";